import { useMsal } from "@azure/msal-react";
import { PrimaryButton } from "@fluentui/react";

export const SignOutButton: React.FC = () => {
    const { instance } = useMsal();

    const handleLogout = (logoutType: string) => {
        if (logoutType === 'popup') {
            instance.logoutPopup();
        } else if (logoutType === 'redirect') {
            instance.logoutRedirect();
        }
    };

    return (
        <div>
            <PrimaryButton text="Sign out" onClick={() => handleLogout('redirect')} /> 
        </div>
    );
};